import moment from 'moment';
import queryString from 'query-string';
import { createLogic } from 'redux-logic';

import { ALTITUDES, getGridApiBaseUri } from '../../config/config-base';

import {
  ISOTHERMS_XHR_DISPATCH,
  ISOTHERMS_XHR_CANCEL,
  ISOTHERMS_XHR_ERROR,
  ISOTHERMS_XHR_SUCCESS,
} from '../actions/isotherms';

const isothermsRequestEpic = createLogic({
  type: ISOTHERMS_XHR_DISPATCH,
  cancelType: ISOTHERMS_XHR_CANCEL,
  latest: true,

  processOptions: {
    dispatchReturn: true,
    successType: ISOTHERMS_XHR_SUCCESS,
    failType: ISOTHERMS_XHR_ERROR,
  },

  process({ getState, action, ajax }) {
    let { init, time, latlngs } = action.payload;

    let settings = {
      crossDomain: true,
      responseType: 'json',
      url:
        `${getGridApiBaseUri()}/cross_section?` +
        queryString.stringify({
          name: 'icon1_ch_icing_aircraft',
          params: ALTITUDES.map((altitude) => `T_${altitude}m`).join(','),
          init: moment.utc(init).format('YYYY-MM-DD HH:mm:ss'),
          time: moment.utc(time).format('YYYY-MM-DD HH:mm:ss'),
          lats: latlngs.map((latlng) => latlng.lat).join(','),
          lons: latlngs.map((latlng) => latlng.lon).join(','),
        }),
    };

    return ajax(settings);
  },
});

const isothermEpic = [isothermsRequestEpic];

export default isothermEpic;
